export default "__VITE_ASSET__430d7104__"